import React from 'react';
import styled from 'styled-components';

import CountUp from 'react-countup';

import { Typography } from '@material-ui/core';

import IconSolarEnergy from '../../../assets/icon-solar-energy.svg';
import ImageScalebloc from '../../../assets/scalebloc.png';
import ImageScalecube from '../../../assets/scalecube.png';

const Root = styled.div`
	max-width: 1000px;

	h3 {
		margin-bottom: 40px;
		font-size: 20px;
		font-weight: bold;
	}

	h6 {
		font-size: 16px;
		font-weight: bold;
	}

	p {
		margin-top: 20px;
		font-size: 14px;
	}

	img {
		max-width: 100px;
		width: 100%;
		height: auto;
		margin: 0 10%;
	}

	.modal-content {
		display: flex;
		margin-top: 40px;

		.modal-text {
			display: flex;
			align-items: center;
			flex: 0 1 calc(50% - 40px);

			&:not(:first-child) {
				margin-left: 40px;
			}
		}

		.modal__product-img {
			max-width: 200px;
			margin: 0 5%;
		}
	}
`;

const EigenverbrauchOptimiert = ({ isStoragePark, data }) => (
	<Root>
		<Typography variant="h3">Ihr optimiertes System</Typography>
		<Typography>
			Einer unserer größten Vorteile liegt darin, dass wir herstellerunabhängig
			sind. Das heißt, Sie bekommen genau die richtige Technologie für ihre
			spezielle Anwendung. Unsere Ingenieure haben unterschiedlichste Systeme
			evaluiert, kennen ihre Stärken und Schwächen.
		</Typography>
		<div className="modal-content">
			<div className="modal-text">
				<img src={IconSolarEnergy} alt="Photovoltaik-Anlage" />
				<div>
					<Typography variant="h6">Photovoltaik(PV)-Anlage</Typography>
					<Typography>
						Zur Bestimmung Ihrer persönlichen PV-Anlage wird die passende
						Größe (kW-Peak) ermittelt. Hierbei wird von einer nutzbaren
						Dachfläche von 8.000 qm ausgegangen. Für eine individuelle
						Bewertung passen Sie bitte die verfügbare Dachfläche im Portfolio
						an. Als Grundlage dieser ersten Auslegung wird Ihr persönliches
						Verbrauchsprofil sowie Ihr Strombezugspreis verwendet.
					</Typography>
					<Typography>
						<strong>
							Unsere Empfehlung:{' '}
							<CountUp
								start={0}
								end={data.pv_size === undefined ? 0 : data.pv_size}
								duration={2.75}
								separator="."
								decimals={2}
								decimal=","
								suffix=" kW-Peak"
							/>
						</strong>
					</Typography>
				</div>
			</div>
			{isStoragePark ? (
				<div className="modal-text">
					<img
						src={ImageScalecube}
						alt="scalecube"
						className="modal__product-img"
					/>
					<div>
						<Typography variant="h6">scalecube</Typography>
						<Typography>
							<strong>scalecube</strong> ist unser System für
							Großverbraucher und eignet sich ideal, um Ihren Standort
							hinsichtlich der intensiven Netznutzung zu optimieren.
						</Typography>
					</div>
				</div>
			) : (
				<div className="modal-text">
					<img
						src={ImageScalebloc}
						alt="scalebloc"
						className="modal__product-img"
					/>
					<div>
						<Typography variant="h6">scalebloc</Typography>
						<Typography>
							<strong>scalebloc</strong> eignet sich besonders für
							kompaktere Anwendungsfälle und gewährleistet eine autarke
							Energieversorgung, sowie zum Einsatz zur Kosten- und
							Eigenverbrauchsoptimierung.
						</Typography>
					</div>
				</div>
			)}
		</div>
	</Root>
);

export default EigenverbrauchOptimiert;
